export default "__VITE_PUBLIC_ASSET__fd9e467a__"